import { User } from "./User";
import { AbstractMesh, TransformNode, Scene, MeshBuilder, StandardMaterial, Mesh, Vector3, Color3, AssetContainer, InstancedMesh } from "@babylonjs/core";
import { createTv } from "./userMeshUtils";
import * as _ from 'lodash';
import { UserSound } from "./UserSound";

export type UserMeshType = 'UserMesh' | 'UserMeshBasic' | 'UserMeshMinimal';

export interface MeshesForUser {
  root: TransformNode;
  nameTag: AbstractMesh;
  tv: AbstractMesh;
  headTransformNode: TransformNode;
  head: AbstractMesh;
  torsoTransformNode: TransformNode;
  torso: AbstractMesh;
  micSound?: UserSound;
}

export abstract class UserMeshBase {
  protected _type: UserMeshType | undefined;
  protected _scene: Scene;
  protected _floatRadians: number;
  protected _floatSpeed: number;
  public user: User;

  get scene() {
    return this._scene;
  }

  get type() {
    return this._type;
  }

  get floatRadians() {
    return this._floatRadians;
  }

  set floatRadians(value: number) {
    this._floatRadians = value;
  }

  get floatSpeed() {
    return this._floatSpeed;
  }

  constructor(user: User, scene: Scene) {
    this.user = user;
    this._scene = scene;
    this._floatRadians = 0;
    this._floatSpeed = Math.random();
  }
}

export class UserMeshMinimal extends UserMeshBase implements MeshesForUser {
  protected _type: UserMeshType = 'UserMeshMinimal';
  public root: TransformNode;
  public nameTag: AbstractMesh;
  public tv: AbstractMesh;
  public headTransformNode: TransformNode;
  public head: AbstractMesh;
  public torsoTransformNode: TransformNode;
  public torso: AbstractMesh;
  public micSound?: UserSound;

  constructor(user: User, meshesForUser: MeshesForUser, scene: Scene) {
    super(user, scene);
  
    this.root = meshesForUser.root;
    this.nameTag = meshesForUser.nameTag;
    this.tv = meshesForUser.tv;
    this.headTransformNode = meshesForUser.headTransformNode;
    this.head = meshesForUser.head;
    this.torsoTransformNode = meshesForUser.torsoTransformNode;
    this.torso = meshesForUser.torso;
    
    // console.log('created minimal user');
  }
}

export class UserMeshBasic extends UserMeshBase implements MeshesForUser{
  protected _type: UserMeshType = 'UserMeshBasic';
  root: TransformNode;
  nameTag: AbstractMesh;
  tv: AbstractMesh;
  headTransformNode: TransformNode;
  head: AbstractMesh;
  torsoTransformNode: TransformNode;
  torso: AbstractMesh;
  micSound?: UserSound;

  constructor(user: User, meshesForUser: MeshesForUser, scene: Scene) {
    super(user, scene);
  
    this.root = meshesForUser.root;
    this.nameTag = meshesForUser.nameTag;
    this.tv = meshesForUser.tv;
    this.headTransformNode = meshesForUser.headTransformNode;
    this.head = meshesForUser.head;
    this.torsoTransformNode = meshesForUser.torsoTransformNode;
    this.torso = meshesForUser.torso;
    
    // console.log('created basic user');
  }
}
